exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".album-article-component{padding-bottom:50px;background-color:#fff}.album-article-component .header a:focus,.album-article-component .header a:hover{color:#999}.album-article-component .header .float-left,.album-article-component .header .float-right{width:50px}.album-article-component .header .title{max-height:44px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/AlbumArticle.scss
// module id = 619
// module chunks = 0